import request from '@/utils/request'
import axios from 'axios'
/**分页查询版本 */
export function fetchList(params) {
  return request({
    url: '/apk/apkVersionQueryPage',
    method: 'get',
    params: params
  })
}
/**添加版本 */
export function createVersion(data) {
  return axios.post('/apk/apkVersionCreate', data)
}


/**编辑版本 */
export function updateApkVersion(data) {

  return axios.post('/apk/apkVersionUpdate', data)
}
/**修改状态 */
export function apkVersionStatusUpdate(data) {

  return axios.post('/apk/apkVersionStatusUpdate', data)
}
/**删除版本 */
export function deleteVersion(id) {

  return axios.post('/apk/apkVersionDel?id=' + id)

}